export enum CsChannel {
  TELEGRAM = "telegram",
  WHATSAPP = "whatsapp",
  LINE = "line",
  MESSENGER = "messenger",
  ZALO = "zalo",
  EMAIL = "email",
  PHONE = "phone",
  OTHER = "other",
}

const HOST_CHANNELS: [string, CsChannel][] = [
  ["t.me", CsChannel.TELEGRAM],
  ["telegram.me", CsChannel.TELEGRAM],
  ["telegram.org", CsChannel.TELEGRAM],
  ["wa.me", CsChannel.WHATSAPP],
  ["whatsapp.com", CsChannel.WHATSAPP],
  ["line.me", CsChannel.LINE],
  ["lin.ee", CsChannel.LINE],
  ["m.me", CsChannel.MESSENGER],
  ["messenger.com", CsChannel.MESSENGER],
  ["facebook.com", CsChannel.MESSENGER],
  ["fb.me", CsChannel.MESSENGER],
  ["fb.com", CsChannel.MESSENGER],
  ["zalo.me", CsChannel.ZALO],
];

export function resolveCsChannel(url?: string): CsChannel {
  if (!url) return CsChannel.OTHER;
  const lower = url.trim().toLowerCase();
  if (lower.startsWith("tel:")) return CsChannel.PHONE;
  if (lower.startsWith("mailto:")) return CsChannel.EMAIL;

  let host: string;
  try {
    host = new URL(lower.includes("://") ? lower : `https://${lower}`).hostname;
  } catch {
    return CsChannel.OTHER;
  }

  const match = HOST_CHANNELS.find(([domain]) => host === domain || host.endsWith(`.${domain}`));
  return match ? match[1] : CsChannel.OTHER;
}
